const RELOAD_FLAG_KEY = 'chunk_load_recovery_reloaded';

function isChunkLoadError(error: unknown): boolean {
  if (!error) {
    return false;
  }

  const message = error instanceof Error ? error.message : JSON.stringify(error);
  const name = error instanceof Error ? error.name : '';

  return (
    name === 'ChunkLoadError' ||
    message.includes('ChunkLoadError') ||
    message.includes('Loading chunk') ||
    message.includes('Failed to fetch dynamically imported module')
  );
}

function isStaleChunkScriptError(event: ErrorEvent): boolean {
  const target = event.target;

  if (!(target instanceof HTMLScriptElement)) {
    return false;
  }

  return (
    isChunkLoadError(event.error ?? event.message) ||
    (typeof event.message === 'string' && event.message.includes("Unexpected token '<'"))
  );
}

function reloadOnceForFreshAssets(): void {
  if (sessionStorage.getItem(RELOAD_FLAG_KEY)) {
    return;
  }

  sessionStorage.setItem(RELOAD_FLAG_KEY, '1');
  const url = new URL(window.location.href);
  url.searchParams.set('_cb', Date.now().toString());
  window.location.replace(url.toString());
}

/**
 * After a deployment, users may still have an old main bundle that requests
 * removed chunk files. Recover by reloading once so the browser fetches the
 * latest index.html and asset manifest.
 */
export function setupChunkLoadRecovery(): void {
  window.addEventListener('unhandledrejection', (event) => {
    if (!isChunkLoadError(event.reason)) {
      return;
    }

    event.preventDefault();
    reloadOnceForFreshAssets();
  });

  window.addEventListener(
    'error',
    (event) => {
      if (!isStaleChunkScriptError(event)) {
        return;
      }

      event.preventDefault();
      reloadOnceForFreshAssets();
    },
    true
  );

  window.addEventListener('load', () => {
    sessionStorage.removeItem(RELOAD_FLAG_KEY);
  });
}
